import React from "react";
import PropTypes from "prop-types";
import { Redirect, Route } from "@/router";

const ConditionalRedirectRoute = ({ redirectCondition, redirectTo, ...props }) => (redirectCondition ? <Redirect to={redirectTo} /> : <Route {...props} />);

ConditionalRedirectRoute.propTypes = {
  redirectCondition: PropTypes.bool,
  redirectTo: PropTypes.string,
};

const ConditionalRedirect = ({ redirectCondition, redirectTo, children }) => (redirectCondition ? <Redirect to={redirectTo} /> : children);

ConditionalRedirect.propTypes = {
  redirectCondition: PropTypes.bool,
  redirectTo: PropTypes.string,
  children: PropTypes.node,
};

export { ConditionalRedirect, ConditionalRedirectRoute };
